export default "__VITE_ASSET__7ff85e70__"